// Pages/ViewBudgetMaster.jsx
import { useEffect, useState } from "react";
import { downloadAllAssetDataExcel } from "../../Api/AssetManagement";
import { Container, Table } from "react-bootstrap";
import moment from "moment";
import { FaDownload } from "react-icons/fa";
import Logo from "../../Components/Logo";
import { useAssetContext } from '../../Context/MasterContext/AssetContext';
import { Link } from "react-router-dom";
import { FaPencilAlt } from "react-icons/fa";


const AssetList = () => {
    const { fetchAssetData,
        loadAssetMaster } = useAssetContext();
    const [loading, setLoading] = useState(false);

    const downloadAsssetExcelData = async () => {
        setLoading(true); // Show loader
        try {
            const response = await downloadAllAssetDataExcel(); // Call the API
            if (!response.data) {
                throw new Error("No data received from server");
            }
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Asset_Data.xlsx');

            // Trigger download
            document.body.appendChild(link);
            link.click();

            // Cleanup
            setTimeout(() => {
                window.URL.revokeObjectURL(url);
                link.parentNode.removeChild(link);
            }, 100);

        } catch (error) {
            console.error("Error downloading data:", error);
        } finally {
            setLoading(false); // Hide loader after API call
        }
    }

    useEffect(() => {
        loadAssetMaster();
    }, []);

    return (
        <>
            <div className="main-content expand">
                <Container fluid className="list-container">
                    {loading && (
                        <div className="loading-overlay">
                            <Logo />
                        </div>
                    )}
                    <div className="page-headings">
                        <div className="heading-name">
                            <h2 className="list-title">Asset Lists</h2>
                        </div>
                        <div className="heading-options">
                            <button className="file-btn download-btn"
                                onClick={downloadAsssetExcelData}
                            >
                                <FaDownload className='file-icon' />
                            </button>
                        </div>
                    </div>

                    {fetchAssetData.length > 0 ? (
                        <Table bordered hover responsive className="data-table">
                            <thead>
                                <tr>
                                    <th>Ser.</th>
                                    <th>Asset ID</th>
                                    <th>OEM Bar Code</th>
                                    <th>Int. Bar Code</th>
                                    <th>Asset Cat.</th>
                                    <th>Asset Type</th>
                                    <th>Brand</th>
                                    <th>Serial No</th>
                                    <th>Department</th>
                                    <th>Purchase Date</th>
                                    <th>PO Number</th>
                                    <th>Inv. Number</th>
                                    <th>Invoice Date</th>
                                    <th>Cost</th>
                                    <th>Supplier Cont. Det.</th>
                                    <th>Warranty Expired</th>
                                    <th>Vendor/AMC ID</th>
                                    <th>Asset Con.</th>
                                    <th>Depreciation Met.</th>
                                    <th>Depreciation Rate</th>
                                    <th>Useful Life</th>
                                    <th>Salvage Value</th>
                                    <th>Date of Dis.</th>
                                    <th>Scrap Value</th>
                                    <th>Remarks</th>
                                    <th>Created At</th>
                                    <th>Created By</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {fetchAssetData.map((budget, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{budget.asset_ID}</td>
                                        <td>{budget.oeM_Barcode}</td>
                                        <td>{budget.internal_BarcodeID}</td>
                                        <td>{budget.asset_Category
                                        }</td>
                                        <td>{budget.asset_Type}</td>
                                        <td>{budget.brand_Model}</td>
                                        <td>{budget.serial_No}</td>
                                        <td>{budget.department}</td>
                                        <td>{budget.purchase_Date
                                        }</td>
                                        <td>{budget.pO_Number}</td>
                                        <td>{budget.invoice_Number
                                        }</td>
                                        <td>{budget.invoice_Date}</td>
                                        <td>{budget.cost}</td>
                                        <td>{budget.supplier_Contact_Details}</td>
                                        <td>{budget.warranty_Expiry}</td>
                                        <td>{budget.vendor_AMCID}</td>

                                        <td>{budget.asset_Condition}</td>
                                        <td>{budget.depreciation_Method
                                        }</td>
                                        <td>{budget.depreciation_Rate}</td>
                                        <td>{budget.useful_Life
                                        }</td>
                                        <td>{budget.salvage_Value}</td>
                                        <td>{budget.date_of_Disposal}</td>
                                        <td>{budget.scrap_Value
                                        }</td>
                                        <td>{budget.remarks}</td>
                                        <td>{moment(budget.createdDate).format('L')} at {budget.createdTime}</td>
                                        <td>{budget.createdBy}</td>
                                        <td>
                                            <Link to={`/assets/update-asset/${budget.asset_ID}`} className="edit-link">
                                                <FaPencilAlt className="edit-icon" />
                                            </Link>

                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ) : (
                        <p className="no-data">No Assets Data found.</p>
                    )}
                </Container>
            </div>
        </>
    );
};

export default AssetList;